//============================================================================
// Redux
//============================================================================
export enum EAAActions {
  StoreInitialState,
  SetInstant,
}
